import React from "react";
import styles from "../../Styles/Playlist/playlist.module.css";
import Hstar from "../../images/Hstar.png";
import Estar from "../../images/Estar.png";
import star from "../../images/star.svg";

const RadioBox = ({ rating, handleFilters, filters }) => {
  const handleChange = (event) => {
    handleFilters(event.target.value);
  };

  return (
    <div>
      {rating.map((count, index) => {
        return (
          <div key={index}>
            {count.name === 0 && (
              <div className={styles.starContainer}>
                <input
                  type="radio"
                  value={`${count._id}`}
                  name="rating"
                  onChange={handleChange}
                  checked={
                    filters ? filters.rating.includes(count.name) : false
                  }
                />
                <img src={Estar} alt="" />
                <img src={Estar} alt="" />
                <img src={Estar} alt="" />
                <img src={Estar} alt="" />
                <img src={Estar} alt="" />
                <span>All</span>
              </div>
            )}
            {count.name === 3 && (
              <div className={styles.starContainer}>
                <input
                  checked={
                    filters ? filters.rating.includes(count.name) : false
                  }
                  type="radio"
                  value={`${count._id}`}
                  name="rating"
                  onChange={handleChange}
                />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={Estar} alt="" />
                <img src={Estar} alt="" />
                <span>3.0+</span>
              </div>
            )}
            {count.name === 3.5 && (
              <div className={styles.starContainer}>
                <input
                  checked={
                    filters ? filters.rating.includes(count.name) : false
                  }
                  type="radio"
                  value={`${count._id}`}
                  name="rating"
                  onChange={handleChange}
                />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={Hstar} alt="" />
                <img src={Estar} alt="" />
                <span>3.5+</span>
              </div>
            )}

            {count.name === 4 && (
              <div className={styles.starContainer}>
                <input
                  checked={
                    filters ? filters.rating.includes(count.name) : false
                  }
                  type="radio"
                  value={`${count._id}`}
                  name="rating"
                  onChange={handleChange}
                />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={Estar} alt="" />
                <span>4.0+</span>
              </div>
            )}
            {count.name === 4.5 && (
              <div className={styles.starContainer}>
                <input
                  checked={
                    filters ? filters.rating.includes(count.name) : false
                  }
                  type="radio"
                  value={`${count._id}`}
                  name="rating"
                  onChange={handleChange}
                />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={Hstar} alt="" />
                <span>4.5+</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RadioBox;
